<div class="modal-header">
    <h3 class="modal-title">User Group: {{name}}</h3>
</div>
<div class="modal-body">
    <input type="text" class="form-control"
           [(ngModel)]="nameFilter"
           (ngModelChange)="filterChanged()"
           placeholder="Filter employees" />
    <label><strong>{{groupMembers.length}} total members  </strong></label><br />
    <button class="btn btn-success" *ngIf="groupMembers.length >  0" (click)="exportExcel()" style="margin-top:5px;margin-bottom:5px;">Export to Excel</button>
    <div style="max-height: 400px; overflow: auto;">
        <table class="table">
            <thead>
                <tr>
                    <th [ngClass]="{'col-lg-6 col-md-6': !isSafari}" (click)="sortGrid('Employee')">
                        <a href="#">
                            Employee Name
                            <span class="modus-icons align-bottom" *ngIf="filterBy === 'Employee' && !reverse">expand_less_bold</span>
                            <span class="modus-icons align-bottom" *ngIf="filterBy === 'Employee' && reverse">expand_more_bold</span>
                        </a>
                    </th>
                    <th [ngClass]="{'col-lg-3 col-md-3': !isSafari}" (click)="sortGrid('PRCo')">
                        <a href="#">
                            PRCo
                            <span class="modus-icons align-bottom" *ngIf="filterBy === 'PRCo' && !reverse">expand_less_bold</span>
                            <span class="modus-icons align-bottom" *ngIf="filterBy === 'PRCo' && reverse">expand_more_bold</span>
                        </a>
                    </th>
                    <th [ngClass]="{'col-lg-3 col-md-3': !isSafari}" (click)="sortGrid('PRGroup')">
                        <a href="#">
                            PRGroup
                            <span class="modus-icons align-bottom" *ngIf="filterBy === 'PRGroup' && !reverse">expand_less_bold</span>
                            <span class="modus-icons align-bottom" *ngIf="filterBy === 'PRGroup' && reverse">expand_more_bold</span>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let member of filteredMembers">
                    <td>{{member.Employee}} - {{member.EmployeeName}}</td>
                    <td>{{member.PRCo}}</td>
                    <td>{{member.PRGroup}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>